<template>
  <div class="wrap">
    <div class="my_page">
      <div class="key_visual addImg mypage">
        <!-- <div class="container">
          <p>마이페이지</p>
        </div> -->
      </div>

      <div class="my_page_content pw_change custom">
        <div class="container">
          <div class="form_area">
            <!-- <form id="my_page_pw_change" action="/mypage_password_change" method="post"
              onsubmit="return formCheckMypagePwChange(this)"> -->
            <form id="my_page_pw_change">
              <input type="hidden" name="return_url" value="/mypage" />
              <div class="my_page_confirm">
                <h3>비밀번호 변경하기</h3>
                <p>
                  회원님의 개인정보를 안전하게 보호하기 위해 주기적으로
                  비밀번호를 변경하시기를 권장합니다.
                </p>
              </div>

              <div class="form_section">
                <div class="table_group">
                  <table class="table_style_1">
                    <tbody>
                      <tr>
                        <th>현재 비밀번호</th>
                        <td>
                          <input
                            id="user_pw"
                            v-model="oldPW"
                            type="password"
                            class="input modify nonBorder"
                            name="user_pw"
                            value=""
                            @blur="checkCurrentPw()"
                          />
                          <span
                            id="checkMsg"
                            v-if="showResult"
                            class="error-messge"
                          >
                            {{ showResult }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <th><span>*</span>새 비밀번호</th>
                        <td>
                          <input
                            id="user_new_pw"
                            v-model="newPW"
                            type="password"
                            class="input modify nonBorder"
                            name="user_new_pw"
                            value=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <th><span>*</span>새 비밀번호 확인</th>
                        <td>
                          <input
                            id="user_new_pw_ok"
                            v-model="newPWChk"
                            type="password"
                            class="input modify nonBorder"
                            name=""
                            value=""
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="pw_description">
                ・영문, 숫자, 특수문자 각 1자리 이상을 조합하여, 최소 8자리
                이상을 입력해주세요.<br />
                사용 가능 특수문자는 ~!@#$%^&* 입니다.
              </div>
              <div class="btn_area">
                <a href="/mypage" class="btn_basic">취소</a>
                <input
                  type="button"
                  class="btn_orange"
                  value="비밀번호 변경 완료"
                  @click="sendData()"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="Modals">
      <ModalAlertChangePW
        :alertMsg="errMsg"
        :isOpen="errStatus"
        :isSucess="changeSucess"
        @update:isOpen="updateStatus"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
// eslint-disable-next-line import/no-cycle
// import router from '../router/router.js'
import { mypagePWChange, myapgePWChk } from '../api/mypage'
import ModalAlertChangePW from '../components/ModalAlertChangePW.vue'

export default {
  name: 'MypagePWChangeViews',
  components: {
    ModalAlertChangePW,
  },
  setup() {
    const errMsg = ref('')
    const errStatus = ref(false)
    const changeSucess = ref(false)
    const showResult = ref('')

    const oldPW = ref('')
    const newPW = ref('')
    const newPWChk = ref('')

    const checkCurrentPw = async () => {
      const enterPWresult = await myapgePWChk(oldPW)
      if (enterPWresult.status_code === 200) {
        showResult.value = ''
      } else {
        showResult.value = '비밀번호가 일치하지 않습니다.'
      }
    }
    const sendData = async () => {
      const sendResult = await mypagePWChange(oldPW, newPW, newPWChk)
      // console.log('비밀번호 변경 시도시 결과값 :: ', sendResult)
      if (sendResult === 'MB41100200') {
        errMsg.value = '비밀번호가 변경되었습니다.'
        errStatus.value = true
        changeSucess.value = true
      } else {
        if (sendResult === 'MB41104400') {
          errMsg.value = '새 비밀번호 확인 값을 잘못 입력하셨습니다.'
          errStatus.value = true
        }
        if (sendResult === 'MB41103400') {
          errMsg.value = '현재 비밀번호와 새 비밀번호가 일치합니다.'
          errStatus.value = true
        }
        if (sendResult === 'MB41105400') {
          errMsg.value =
            '비밀번호 입력 규칙이 맞지 않습니다. <br>  8자~20자 영문 대소문자, 숫자, 특수문자를 사용해주세요.'
          errStatus.value = true
        }
        if (sendResult === '4000001') {
          errMsg.value = '다시 로그인해주세요.'
          errStatus.value = true
        }
      }
    }

    const updateStatus = () => {
      errStatus.value = false
    }
    onMounted(() => {})
    return {
      errMsg,
      errStatus,
      changeSucess,
      updateStatus,

      showResult,

      oldPW,
      newPW,
      newPWChk,
      checkCurrentPw,
      sendData,
    }
  },
}
</script>
